module.exports = __webpack_public_path__ + "img/mon.faefb4b9.webp";